import React, { useState } from 'react';
import '../styles/Contact.css';
import { createContact } from '../services/api';

function Contact() {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    sujet: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await createContact(formData);
      
      setSuccess(true);
      setFormData({
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        sujet: '',
        message: '',
      });

      setTimeout(() => setSuccess(false), 5000);
    } catch (error) {
      alert('Erreur lors de l\'envoi du message');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="contact-container">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Contactez-nous</h1>
          <p>Nous sommes à votre écoute pour toute question ou suggestion</p>
        </div>
      </section>

      <div className="contact-main">
        <div className="container">
          <div className="contact-grid">
            {/* Formulaire */}
            <div className="contact-form-section">
              <h2>Envoyez-nous un message</h2>
              <p className="form-description">
                Remplissez le formulaire ci-dessous et nous vous répondrons dans les plus brefs délais.
              </p>

              {success && (
                <div className="success-message">
                  ✅ Votre message a été envoyé avec succès ! Nous vous répondrons rapidement.
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>Nom *</label>
                    <input
                      type="text"
                      name="nom"
                      value={formData.nom}
                      onChange={handleChange}
                      required
                      placeholder="Votre nom"
                    />
                  </div>

                  <div className="form-group">
                    <label>Prénom *</label>
                    <input
                      type="text"
                      name="prenom"
                      value={formData.prenom}
                      onChange={handleChange}
                      required
                      placeholder="Votre prénom"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="votre@email.com"
                    />
                  </div>

                  <div className="form-group">
                    <label>Téléphone</label>
                    <input
                      type="tel"
                      name="telephone"
                      value={formData.telephone}
                      onChange={handleChange}
                      placeholder="06 12 34 56 78"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Sujet *</label>
                  <select
                    name="sujet"
                    value={formData.sujet}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Choisissez un sujet</option>
                    <option value="information">Demande d'information</option>
                    <option value="benevole">Devenir bénévole</option>
                    <option value="partenariat">Partenariat</option>
                    <option value="permanence">Permanence numérique</option>
                    <option value="don">Faire un don</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Message *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Écrivez votre message ici..."
                  ></textarea>
                </div>

                <button type="submit" className="btn-submit" disabled={loading}>
                  {loading ? 'Envoi en cours...' : 'Envoyer le message'}
                </button>
              </form>
            </div>

            {/* Informations de contact */}
            <div className="contact-info-section">
              {/* <h2>Nos coordonnées</h2> */}

              <div className="info-card">
                {/* <div className="info-icon">📧</div> */}
                <h3>Email</h3>
                <p>
                  <a href="mailto:asifc.rhone@gmail.com">asifc.rhone@gmail.com</a>
                </p>
              </div>

              <div className="info-card">
                {/* <div className="info-icon">📍</div> */}
                <h3>Adresse</h3>
                <p>
                  13 avenue Marcel Paul<br/> Vénissieux 69200
                </p>
              </div>

              <div className="info-card">
                {/* <div className="info-icon">⏰</div> */}
                <h3>Horaires</h3>
                <p>
                  Lundi - Vendredi<br />
                  9h00 - 18h00
                </p>
              </div>

              <div className="info-card">
                {/* <div className="info-icon">🤝</div> */}
                <h3>Réseaux sociaux</h3>
                <div className="social-links">
                  <a href="https://www.facebook.com/p/Association-Solidarit%C3%A9-Internationale-France-Comores-Rh%C3%B4ne-ASIFC-Rh%C3%B4ne-100086731297999/" className="social-link">Facebook</a>
                  <a href="https://www.instagram.com/asifcrhone/" className="social-link">Instagram</a>
                </div>
              </div>

              <div className="cta-box">
                <h3>Envie de nous rejoindre ?</h3>
                <p>Devenez bénévole et contribuez à nos projets solidaires.</p>
                <a href="/benevole" className="btn-cta">Devenir bénévole</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;